<template>
    <validation-observer ref="changePass">
         <b-form class="formBox">  
            <validation-provider :name="$t('user.form.currentPw')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('user.form.currentPw')" label-for="oldPass">
                        <b-form-input
                            id="oldPass"
                            v-model="old_pass"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            type="password"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>
            
             <validation-provider :name="$t('user.form.password')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('user.form.password')" label-for="password">
                        <b-form-input
                            id="password"
                            v-model="new_pass"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            type="password"

                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

               <validation-provider :name="$t('user.form.passwordAgain')" :rules="{ required: true, min: 3, is: new_pass}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('user.form.passwordAgain')" label-for="password2">
                        <b-form-input
                            id="password2"
                            v-model="new_pass_retry"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            type="password"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>
              
         </b-form>
        </validation-observer>
</template>
               
<script>

    export default {
        name: "ChangePassword",
        data: function(){
            return{
                new_pass:  "" ,
                new_pass_retry:  "",
                old_pass: "",
            }
        },
       
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        },

    }
</script>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/components/ChangePassword.vue